import { render, staticRenderFns } from "./SMSTemplatePicker.vue?vue&type=template&id=fc164052&scoped=true"
import script from "./SMSTemplatePicker.vue?vue&type=script&lang=js"
export * from "./SMSTemplatePicker.vue?vue&type=script&lang=js"
import style0 from "./SMSTemplatePicker.vue?vue&type=style&index=0&id=fc164052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc164052",
  null
  
)

export default component.exports